<template>
  <div id="hress3u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHress3uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :tab1Table="columns[dash.nowLang].columnsTab1"
            :tab2Table="columns[dash.nowLang].columnsTab2"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hress3u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>
   
    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :postHress3uSendApprove="postHress3uSendApprove" 
            :codappr="codempid"
            :detailSubmit="detailSubmit"
            :descCodappr="dash.currentUser.username[dash.nowLang]" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hress3u/mutation-types'
import detail from 'components/hress3u/detail'
import popupApprove from 'components/hress3u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hress3u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHress3uColumnsLabels()
    this.receivedHress3uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRESS3U_INDEX_DISP,
      detailDisp: types.GET_HRESS3U_DETAIL_DISP,
      columns: types.GET_HRESS3U_COLUMNS,
      labels: types.GET_HRESS3U_LABELS,
      index: types.GET_HRESS3U_INDEX,
      indexSelected: types.GET_HRESS3U_INDEX_SELECTED,
      detail: types.GET_HRESS3U_DETAIL,
      detailSubmit: types.GET_HRESS3U_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHress3uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHress3uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRESS3U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRESS3U_PAGE,
      receivedHress3uColumnsLabels: types.RECEIVED_HRESS3U_COLUMNS_LABELS,
      receivedHress3uIndex: types.RECEIVED_HRESS3U_INDEX,
      receivedHress3uDetail: types.RECEIVED_HRESS3U_DETAIL,
      receivedHress3uDetailSubmit: types.RECEIVED_HRESS3U_DETAIL_SUBMIT,
      postHress3uSendApprove: types.POST_HRESS3U_SEND_APPROVE
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?321faed2